import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireRole }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="wave-bars" data-testid="auth-loading"><span/><span/><span/><span/><span/></div>
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  if (requireRole && user.role !== requireRole) return <Navigate to="/app/dashboard" replace />;
  return children;
}
